import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { ReactComponent as IconList } from "../../assets/icon_list.svg";
import { useAuth } from "../../hooks/auth";

import { Wrapper } from "./styles";

export default function Home() {
  const history = useHistory();
  const { roles } = useAuth();

  const isPermitted = useCallback(
    (role) => {
      const data = (roles || []).filter(
        (value) =>
          value.toLocaleUpperCase() === `ROLE_SSA_${role.toLocaleUpperCase()}`
      );

      return data.length > 0;
    },
    [roles]
  );

  return (
    <Wrapper>
      <div className="row">
        {isPermitted("SIP3W") && (
          <div className="card-01" onClick={() => history.push("/sip3w")}>
            <div className="card-03">
              <div className="subtitle-card">
                Validação da comissão do SIP3W
              </div>
            </div>
            <div className="card-icon-orange">
              <div className="img-icon">
                <IconList className="iconComponent" />
              </div>
              <div className="title-card">SIP3W</div>
            </div>
          </div>
        )}

        {isPermitted("INTELIGENCIA_DIP") && (
          <div className="card-01" onClick={() => history.push("/dip")}>
            <div className="card-03">
              <div className="subtitle-card">
                Validação da inteligência (DIP)
              </div>
            </div>
            <div className="card-icon-orange">
              <div className="img-icon">
                <IconList className="iconComponent" />
              </div>
              <div className="title-card">DIP</div>
            </div>
          </div>
        )}

        {isPermitted("INTELIGENCIA_ASINT") && (
          <div className="card-01" onClick={() => history.push("/asint")}>
            <div className="card-03">
              <div className="subtitle-card">
                Validação pela Inteligência (ASINT)
              </div>
            </div>
            <div className="card-icon-yello">
              <div className="img-icon">
                <IconList className="iconComponent" />
              </div>
              <div className="title-card">ASINT</div>
            </div>
          </div>
        )}

        {isPermitted("INTELIGENCIA_ASSINT") && (
          <div className="card-01" onClick={() => history.push("/assint")}>
            <div className="card-03">
              <div className="subtitle-card">
                Validação pela Inteligência (ASSINT)
              </div>
            </div>
            <div className="card-icon-green">
              <div className="img-icon">
                <IconList className="iconComponent" />
              </div>
              <div className="title-card">ASSINT</div>
            </div>
          </div>
        )}

        {isPermitted("INTELIGENCIA_COIN") && (
          <div className="card-01" onClick={() => history.push("/coin")}>
            <div className="card-03">
              <div className="subtitle-card">
                Validação pela Inteligência (COIN)
              </div>
            </div>
            <div className="card-icon-green">
              <div className="img-icon">
                <IconList className="iconComponent" />
              </div>
              <div className="title-card">COIN</div>
            </div>
          </div>
        )}
      </div>
      <div className="row">
        {isPermitted("EXECUTIVO") && (
          <div className="card-01" onClick={() => history.push("/secretario")}>
            <div className="card-03">
              <div className="subtitle-card">
                Validação pelo Secretário executivo
              </div>
            </div>
            <div className="card-icon-red">
              <div className="img-icon">
                <IconList className="iconComponent" />
              </div>
              <div className="title-card">EXECUTIVO</div>
            </div>
          </div>
        )}

        {isPermitted("COTIC") && (
          <div className="card-01" onClick={() => history.push("/cotic")}>
            <div className="card-03">
              <div className="subtitle-card">
                Liberação das permissões para os usuários
              </div>
            </div>
            <div className="card-icon-green">
              <div className="img-icon">
                <IconList className="iconComponent" />
              </div>
              <div className="title-card">COTIC</div>
            </div>
          </div>
        )}

        {isPermitted("AUDITORIA") && (
          <div className="card-01" onClick={() => history.push("/auditoria")}>
            <div className="card-03">
              <div className="subtitle-card">Auditoria de acesso</div>
            </div>
            <div className="card-icon-green">
              <div className="img-icon">
                <IconList className="iconComponent" />
              </div>
              <div className="title-card">Auditoria</div>
            </div>
          </div>
        )}

        {isPermitted("COTIC") && (
          <div className="card-01" onClick={() => history.push("/user/cpf")}>
            <div className="card-03">
              <div className="subtitle-card">Consulta as fichas por CPF</div>
            </div>
            <div className="card-icon-green">
              <div className="img-icon">
                <IconList className="iconComponent" />
              </div>
              <div className="title-card">FICHA</div>
            </div>
          </div>
        )}

        {isPermitted("ESTAGIO") && (
          <div className="card-01" onClick={() => history.push("/estagios")}>
            <div className="card-03">
              <div className="subtitle-card">Fichas de Estagiarios</div>
            </div>
            <div className="card-icon-green">
              <div className="img-icon">
                <IconList className="iconComponent" />
              </div>
              <div className="title-card">ESTÁGIO</div>
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  );
}
